<template>
    <div class="file-preview m-1 relative aspect-square overflow-hidden rounded-xl flex flex-col border border-neutral-3 bg-neutral-2 whitespace-pre-wrap">
        <div @click.prevent="$emit('remove', link._id)"  class="h-6- w-6 rounded-bl flex justify-center bg-primary-extra-dark text-white hover:bg-secondary-dark hover:text-primary-extra-dark items-center cursor-pointer absolute top-0 right-0" aria-label="Remove">
            x
        </div>
        <div v-if="defaultThumbnail" class="w-full h-full rounded-t bg-primary-dark flex flex-col justify-center items-center text-primary-extra-dark text-bold text-2xl">
            <div>{{ defaultThumbnail }}</div>
        </div>
        <img v-else  class="w-full h-full block object-cover rounded-t-xl whitespace-pre-wrap" :src="link.link" />
    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
const props = defineProps(['link'])
defineEmits(['remove'])

const defaultThumbnail = computed(() => {
    if(props.link.extension == '. ppt') {
        return 'PPT'
    } else if(props.link.extension == '. pdf') {
        return 'PDF'
    } else {
        return null
    }
})


</script>